import { cn } from '@/lib/utils';

export function EmptyState({
  icon: Icon,
  title,
  description,
  cta,
  secondaryAction,
  variant = 'full',
  className,
  testid = 'empty-state',
}) {
  const isCompact = variant === 'compact';
  const iconSize = isCompact ? 32 : 48;
  const padding = isCompact ? 'py-6' : 'py-12';

  return (
    <div data-testid={testid} className={cn(
      'flex flex-col items-center justify-center px-6 max-w-[320px] mx-auto text-center',
      padding,
      className
    )}>
      {Icon && (
        <Icon
          size={iconSize}
          strokeWidth={1.5}
          className="text-[var(--label-tertiary)] mb-4"
        />
      )}
      <h3 className={cn(
        isCompact ? 'text-[17px] font-semibold' : 'text-[20px] font-semibold',
        'text-[var(--label-primary)] mb-2'
      )}>
        {title}
      </h3>
      {description && (
        <p className="text-[16px] text-[var(--label-secondary)] mb-6 leading-relaxed">
          {description}
        </p>
      )}
      {cta && (
        <button
          data-testid={`${testid}-cta`}
          onClick={cta.onClick}
          className={cn(
            'h-[44px] px-6 rounded-xl text-white text-[17px] font-semibold',
            'shadow-[inset_0_1px_0_rgba(255,255,255,0.15)]',
            'active:opacity-90 active:scale-[0.97] transition-all duration-100',
            cta.accent === 'troedel' && 'bg-[var(--accent-troedel)]',
            cta.accent === 'stand'   && 'bg-[var(--accent-stand)]',
            (!cta.accent || cta.accent === 'online') && 'bg-[var(--accent-online)]',
          )}
        >
          {cta.label}
        </button>
      )}
      {secondaryAction && (
        <button
          onClick={secondaryAction.onClick}
          className="mt-3 text-[16px] text-[var(--accent-online)] active:opacity-70 transition-opacity duration-100"
        >
          {secondaryAction.label}
        </button>
      )}
    </div>
  );
}
